import { StyleSheet } from '../../../../components/Common/react-native-components';

export const dropdownStyling = {
  container: {
    minHeight: 32,
    maxHeight: 32,
    borderRadius: 16,
    borderWidth: 1,
    width: 140,
    minWidth: 200,
    borderColor: '#8F95A4',
    backgroundColor: '#F8F9FA'
  },

  dropDownText: {
    marginEnd: 0
  },
  icon: {
    height: 22
  },
  optionContainer: {
    minWidth: 150,
    maxWidth: 300
  }
};

export const overviewCompStyling = () => {
  return StyleSheet.create({
    pieChartContainer: {
      padding: 20,
      width: 160,
      textAlign: 'center',
      backgroundColor: 'black',
      borderRadius: 10,
      alignItems: 'center'
    },
    tooltipLabel: {
      textAlign: 'center'
    },
    tooltipValue: {
      marginBottom: 10
    }
  });
};
